import { Info } from 'lucide-react';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from './ui/tooltip';

/**
 * InfoTooltip — small (i) icon that reveals a plain-English explanation
 * on hover/focus. Standardises the "?" pattern across every KPI, chart,
 * and table so non-technical staff always know what a number means.
 *
 * Props:
 *   text     — string OR node to render inside the popover
 *   side     — Radix tooltip side (default 'top')
 *   size     — icon size in px (default 14)
 *   className— extra wrapper classes
 *   testId   — optional data-testid, defaults to 'info-tooltip'
 */
export function InfoTooltip({ text, side = 'top', size = 14, className = '', testId = 'info-tooltip' }) {
  if (!text) return null;
  return (
    <TooltipProvider delayDuration={120}>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            aria-label="More info"
            data-testid={testId}
            className={`inline-flex items-center justify-center text-[#685B72]/60 hover:text-[#685B72] transition-colors align-middle ml-1 ${className}`}
            onClick={(e) => e.preventDefault()}
          >
            <Info size={size} strokeWidth={2} />
          </button>
        </TooltipTrigger>
        <TooltipContent
          side={side}
          sideOffset={6}
          className="max-w-xs bg-[#2D2833] text-white text-[12px] leading-relaxed px-3 py-2 rounded-lg shadow-lg"
        >
          {text}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}

export default InfoTooltip;
